import { createAction, props } from '@ngrx/store';
import { FormBuilderConfig } from '../models/form-builder.models';
import { UploadedFile } from '../../../lib/ni-file-upload/ni-file-upload.component';

// Load Form Configuration Actions
export const loadFormConfig = createAction(
  '[Form Builder] Load Form Config',
  props<{ programId: string }>()
);

export const loadFormConfigSuccess = createAction(
  '[Form Builder] Load Form Config Success',
  props<{ config: FormBuilderConfig }>()
);

export const loadFormConfigFailure = createAction(
  '[Form Builder] Load Form Config Failure',
  props<{ error: any }>()
);

// Update Form Values Actions
export const updateFormValue = createAction(
  '[Form Builder] Update Form Value',
  props<{ fieldId: string; value: any }>()
);

export const updateFormValues = createAction(
  '[Form Builder] Update Form Values',
  props<{ values: Record<string, any> }>()
);

export const updateTableData = createAction(
  '[Form Builder] Update Table Data',
  props<{ groupId: string; tableData: any[] }>()
);

// Update Group Visibility Action
export const updateGroupVisibility = createAction(
  '[Form Builder] Update Group Visibility',
  props<{ groupId: string; isVisible: boolean; sectionId?: string }>()
);

export const updateCurrentSection = createAction(
  '[Form Builder] Update Current Section',
  props<{ sectionId: string }>()
);

// Submit Form Actions
export const submitForm = createAction(
  '[Form Builder] Submit Form',
  props<{ status: 'draft' | 'pending' | 're-submit' }>()
);

export const submitFormSuccess = createAction(
  '[Form Builder] Submit Form Success',
  props<{ response: any }>()
);

export const submitFormFailure = createAction(
  '[Form Builder] Submit Form Failure',
  props<{ error: any }>()
);

// Reset Form Action
export const resetForm = createAction(
  '[Form Builder] Reset Form'
);

// Load Persisted Data Actions
export const loadPersistedData = createAction(
  '[Form Builder] Load Persisted Data',
  props<{ programId?: string }>()
);

export const loadPersistedDataSuccess = createAction(
  '[Form Builder] Load Persisted Data Success',
  props<{ formValues: Record<string, any>; currentSectionId?: string }>()
);

// Save & Exit Action (clears baseline)
export const saveAndExit = createAction(
  '[Form Builder] Save And Exit'
);

// Add Group to Section Action
export const addGroupToSection = createAction(
  '[Form Builder] Add Group To Section',
  props<{ sectionId: string; group: any }>()
);

// Update Group Data Action
export const updateGroupData = createAction(
  '[Form Builder] Update Group Data',
  props<{ sectionId: string; groupId: string; data: Record<string, any[]> }>()
);

// Update Uploaded Files Map Action
export const updateUploadedFilesMap = createAction(
  '[Form Builder] Update Uploaded Files Map',
  props<{ uploadedFilesMap: Record<string, UploadedFile[]> }>()
);

